import React, { useEffect, useState } from "react";
import "../../modal.css";

export default function ServiceModal({ agentName, empId, CloseChat, handleSubmit, handleClosePop, selectOption, setFeedback, openModal, option, restartChat, serviceAgentFeedback, GAEvent, askForRatingTicket, ticketRatingDone, ticketInactivityClosed , handleTicketSubmit, setQueryResolvedStatus, handleQueryResolvedSubmit, handleSubmitService}) {
  const [askForRating, setAskForRating] = useState(true)
  const [negativeBox, setnegativeBox] = useState(false)
  const [negativeMcq, setNegativeMcq] = useState([]);
  const [negativeBoxtextarea, setNegativeBoxtextarea] = useState(false);
  const [agentCsatQuestionCode, setAgentCsatQuestionCode] = useState("");
  const [agentCsatRemark, setAgentCsatRemark] = useState("");
  const [loader, setLoader] = useState(false)
  const [submitFeedback, setSubmitFeedback] = useState(false)
  const [matrixCsat, setMatrixCsat] = useState(true);
  const [loaderState, setLoaderState] = useState(false)
  const [csatTicketDone, setCsatTicketDone] = useState(false)
  useEffect(() => {
    if (agentName) {
      GAEvent({ eventAction: "csat-display", eventLabel: "csat-agent" })
    } else {
      GAEvent({ eventAction: "csat-display", eventLabel: "csat-bot" })
    }
  }, [])
  const ratingGood = async () => {
    selectOption("Good");
    setAskForRating(false);
    setLoader(true)
    if (matrixCsat) {
      GAEvent({ eventAction: "csat-good", eventLabel: "csat-agent" })
      let resp = await callServiceApi({
        "QuestionCode": "Experience_Feedback",
        "AnswerCode": "Good",
        "OptionType": "Feedback"
      });
      if (resp?.result?.IsSessionStoped) {
        setSubmitFeedback(true)
      }
      if (resp) {
        agentCsat(resp.result)
      }
      agentCsat(null);
    } else {
      GAEvent({ eventAction: "csat-good", eventLabel: "csat-bot" })
      setSubmitFeedback(true)
    }

  }

  const ratingTicketGood = async () => {
    setCsatTicketDone(true);
    GAEvent({ eventAction: "csat-good", eventLabel: "csat-agent" })
    let resp = await callServiceApi({
      "QuestionCode": "Experience_Feedback",
      "AnswerCode": "Good",
      "OptionType": "Feedback"
    });
    handleTicketSubmit("Good");
  }

  const queryResolvedNo = async () => {
    setQueryResolvedStatus("No");
    handleQueryResolvedSubmit();
  }
  const queryResolveYes = async () => {
    setQueryResolvedStatus("Yes");
    handleQueryResolvedSubmit();
  }

  const ratingBad = async () => {
    selectOption("Bad");
    if (matrixCsat) {
      GAEvent({ eventAction: "csat-bad", eventLabel: "csat-agent" })
      let resp = await callServiceApi({
        "QuestionCode": "Experience_Feedback",
        "AnswerCode": "Bad",
        "OptionType": "Feedback"
      });
      if (resp?.result?.IsSessionStoped) {
        setSubmitFeedback(true)
        return;
      }
      setAskForRating(false);
      if (resp) {
        agentCsat(resp.result)
      }
    } else {
      GAEvent({eventAction:"csat-bad",eventLabel: "csat-bot"})
      setSubmitFeedback(true)
    }
  }
  const callServiceApi = async (obj) => {
    setLoaderState(true)
    let resp = await serviceAgentFeedback(obj);
    setLoaderState(!true)
    if (!resp.result) {
      setSubmitFeedback(true)
      return
    }
    return resp;
  }
  const agentCsat = async (obj) => {
    if (obj) {
      setAgentCsatQuestionCode(obj.QuestionCode || '');

      if (obj.QuestionType == 'Selection') {
        setnegativeBox(true);
        setNegativeMcq(obj.QuestionOptions);
      }

      if (obj.OptionCode == "Others") {
        setNegativeMcq([]);
        setNegativeBoxtextarea(true);
      }
    }
    else {
      setSubmitFeedback(true)
    }
  }

  const handleAgentCsat = async (obj) => {
    // console.log(obj);
    if ((obj.QuestionType == 'Selection' || obj.OptionType == 'Selection') ){//&& obj.OptionCode != "Others") {
      let resp = await callServiceApi({
        'QuestionCode': agentCsatQuestionCode,
        'AnswerCode': obj.OptionCode,
        'OptionType': obj.OptionType
      });

      if (resp.result?.IsSessionStoped == true) {
        setSubmitFeedback(true)
      }
      if(resp.result?.QuestionOptions[0].OptionCode == "Comments"){
        setNegativeMcq([]);
        setNegativeBoxtextarea(true);
      }
      console.log(resp.result);
    }
    // if (obj.OptionCode == "Others" || obj.OptionCode == "Comments" ) {
    //   setNegativeMcq([]);
    //   setNegativeBoxtextarea(true);
    // }
  }
  const remarkSubmission = async () => {
    let resp = await callServiceApi({
      'QuestionCode': 'Comment_Feedback',//agentCsatQuestionCode,
      'AnswerCode': agentCsatRemark,
      'OptionType': "Comments"
    });
    if (resp.result?.IsSessionStoped == true) {
      setFeedback(agentCsatRemark);
      setSubmitFeedback(true)
    }
  }

  useEffect(() => {
    if (submitFeedback) {
      // handleSubmit()
      handleSubmitService();
    }
  }, [submitFeedback])

  const loaderView = <>
    <div style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1000
    }}>
      <div style={{
        display: 'block',
        position: 'relative',
        left: '50%',
        top: '50%',
        width: '100px',
        height: '100px',

      }}>
        <div class="dot-typing"></div>
      </div>
    </div>
  </>

  return (

    <div id="popup1" className={`overlay  ${openModal}`}>
      <div className="chatpopup">
        {loaderState ? loaderView : ''}
        <div className="feedback-share" style={{ position: "relative" }}>
          {askForRating && !askForRatingTicket ?
            <div className="sm-feedback">
              {/* <div onClick={CloseChat} className="closeIcon">&#x2715;</div> */}
              {agentName ?
                <div className="heading">{`How was your experience with our advisor, ${agentName} (${empId})?`}</div>
                :
                <div className="heading">Overall, how would you rate your chat experience?</div>
              }
              <div className="feedback-box">
                <input type="radio" name="select" id="option-1" />
                <input type="radio" name="select" id="option-2" />

                <label for="option-2" className={`option option-1 ${option === 'Bad' ? "active" : ""}`} onClick={() => ratingGood()}>
                  <div className="dot bad"></div>
                  <span>Good</span>
                </label>
                <label for="option-1" className={`option option-2 ${option === 'Good' ? "active" : ""}`} onClick={() => ratingBad()}>
                  <div className="dot good"></div>
                  <span>Bad</span>
                </label>
              </div>
              <div class="restartChat">Still have a query? <span onClick={() => restartChat()}>Restart Chat</span></div>
            </div>
            : ''} 

          {askForRating && askForRatingTicket && !csatTicketDone ?
            <div className="sm-feedback">
              {/* <div onClick={CloseChat} className="closeIcon">&#x2715;</div> */}
              {agentName ?
                <>
                  <div className="heading">{`How was your experience with our advisor, ${agentName} (${empId})?`}</div>
                  <div className="feedback-box">
                    <input type="radio" name="select" id="option-1" />
                    <input type="radio" name="select" id="option-2" />

                    <label for="option-2" className={`option option-1 ${option === 'Bad' ? "active" : ""}`} onClick={() => ratingTicketGood()}>
                      <div className="dot bad"></div>
                      <span>Good</span>
                    </label>
                    <label for="option-1" className={`option option-2 ${option === 'Good' ? "active" : ""}`} onClick={() => ratingBad()}>
                      <div className="dot good"></div>
                      <span>Bad</span>
                    </label>
                  </div>
                </>
                :
                <>
                  <div className="heading">Overall, how would you rate your chat experience?</div>
                  <div className="feedback-box">
                    <input type="radio" name="select" id="option-1" />
                    <input type="radio" name="select" id="option-2" />

                    <label for="option-2" className={`option option-1 ${option === 'Bad' ? "active" : ""}`} onClick={() => ratingGood()}>
                      <div className="dot bad"></div>
                      <span>Good</span>
                    </label>
                    <label for="option-1" className={`option option-2 ${option === 'Good' ? "active" : ""}`} onClick={() => ratingBad()}>
                      <div className="dot good"></div>
                      <span>Bad</span>
                    </label>
                  </div>
                </>
              }

              <div class="restartChat">Still have a query? <span onClick={() => restartChat()}>Restart Chat</span></div>
            </div>
            : ''} 

          {askForRating && askForRatingTicket && csatTicketDone && !loaderState && agentName?
            <div className="sm-feedback">
              {/* <div onClick={CloseChat} className="closeIcon">&#x2715;</div> */}
              <div className="heading">Were we able to resolve your query?</div>
              <div className="feedback-box">
                <input type="radio" name="select" id="option-1" />
                <input type="radio" name="select" id="option-2" />

                <label for="option-1" className={`option option-2 ${option === 'Good' ? "active" : ""}`}>
                  <span onClick={() => queryResolvedNo()}>👎 No</span>
                </label>
                <label for="option-2" className={`option option-1 ${option === 'Bad' ? "active" : ""}`}>
                  <span onClick={() => queryResolveYes()}>👍 Yes</span>
                </label>
              </div>
              <div class="restartChat">Still have a query? <span onClick={() => restartChat()}>Restart Chat</span></div>
            </div> : null}




          {/* {askForRating && askForRatingTicket && !ticketRatingDone ?
            <>
              {agentName ? <div className="sm-feedback">
                <div onClick={CloseChat} className="closeIcon">&#x2715;</div>
                <div className="heading">Did our advisor resolve your query to your satisfaction today?</div>
                <div className="feedback-box">
                  <input type="radio" name="select" id="option-1" />
                  <input type="radio" name="select" id="option-2" />

                  <label for="option-1" className={`option option-2 ${option === 'Good' ? "active" : ""}`} onClick={() => ratingBad()}>
                    <span>👎 No</span>
                  </label>
                  <label for="option-2" className={`option option-1 ${option === 'Bad' ? "active" : ""}`} onClick={() => ratingGood()}>
                    <span>👍 Yes</span>
                  </label>
                </div>
                <div class="restartChat">Still have a query? <span onClick={() => restartChat()}>Restart Chat</span></div>
              </div> : <div className="sm-feedback">
                <div onClick={CloseChat} className="closeIcon">&#x2715;</div>
                {agentName ?
                  <div className="heading">{`How was your experience with our advisor, ${agentName} (${empId})?`}</div>
                  :
                  <div className="heading">Overall, how would you rate your chat experience?</div>
                }
                <div className="feedback-box">
                  <input type="radio" name="select" id="option-1" />
                  <input type="radio" name="select" id="option-2" />

                  <label for="option-2" className={`option option-1 ${option === 'Bad' ? "active" : ""}`} onClick={() => ratingGood()}>
                    <div className="dot bad"></div>
                    <span>Good</span>
                  </label>
                  <label for="option-1" className={`option option-2 ${option === 'Good' ? "active" : ""}`} onClick={() => ratingBad()}>
                    <div className="dot good"></div>
                    <span>Bad</span>
                  </label>
                </div>
                <div class="restartChat">Still have a query? <span onClick={() => restartChat()}>Restart Chat</span></div>
              </div>}
            </>
            : ''} 

           {askForRating && askForRatingTicket && ticketRatingDone && agentName ?
            <div className="sm-feedback">
              {ticketInactivityClosed ? <div className="heading">The chat was closed due to inactivity. Please start a new chat if you need assistance.</div>
                : <div className="heading">Your chat session has ended.</div>
              }
              <div class="restartChat">Still have a query? <span onClick={() => restartChat()}>Restart Chat</span></div>

            </div>

            : ''} */}
          {negativeBox ?
            <>
              <div class="reasonForClose">
                <div className="heading textleft">We are sorry to hear that. What went wrong?</div>
                <div class="mcq-forClose">
                  {negativeMcq ?

                    negativeMcq.map((obj, index) => {
                      return (
                        <>
                          <span onClick={() => handleAgentCsat(obj)}>{obj.OptionText}</span>
                          {/* <span className="clear"></span> */}
                        </>
                      )
                    })

                    : ""}
                  {negativeBoxtextarea ?
                    <>
                      <textarea value={agentCsatRemark}
                        onChange={(e) => { setAgentCsatRemark(e.target.value) }}
                        placeholder="Please Enter Your Feedback">
                      </textarea>
                      <a className="btn" onClick={() => remarkSubmission()}>Submit feedback</a>
                    </>
                    : ''}
                </div>
              </div>
              <div class="restartChat">Still have a query? <span onClick={() => restartChat()}>Restart Chat</span></div>
            </>
            : ''}

        </div>
      </div>
    </div >
  );
}
